/*
 * ARCANIA EFFECTS
 * サイト全体の装飾エフェクトを集約するファイル。
 * Inova/Concept テーマアップデート時に layout/theme.liquid への独自改修を
 * 最小化するため、エフェクトの DOM 生成と初期化はここに集約する。
 *
 * 現在のエフェクト:
 *   - ARCANIA EMBERS（火の粉）
 *   - ARCANIA SPOTLIGHT（サーチライト）
 *
 * prefers-reduced-motion 対応は arcania-effects.css 側でも維持している。
 */
(function () {
  var ARCANIA_EFFECTS = {
  embers: true,
  spotlight: true,
  scrollspy: true
};

if (ARCANIA_EFFECTS.embers) initEmbers();
if (ARCANIA_EFFECTS.spotlight) initSpotlight();
if (ARCANIA_EFFECTS.scrollspy) initArcaniaScrollspy();

  function initEmbers() {
    if (window.__arcaniaEmbersInit) return;
    window.__arcaniaEmbersInit = true;

    function init() {
      var holder = document.querySelector('[data-arcania-embers]');
      if (!holder) {
        holder = document.createElement('div');
        holder.className = 'arcania-embers';
        holder.setAttribute('data-arcania-embers', '');
        holder.setAttribute('aria-hidden', 'true');
        document.body.appendChild(holder);
      }
      if (holder.childElementCount > 0) return;
      var count = 18;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < count; i++) {
        var s = document.createElement('span');
        s.className = 'arcania-embers__particle';
        var size = 1.5 + Math.random() * 2.5;
        s.style.left   = (Math.random() * 100) + '%';
        s.style.width  = size + 'px';
        s.style.height = size + 'px';
        s.style.opacity = (0.4 + Math.random() * 0.5).toFixed(2);
        s.style.animationDuration = (12 + Math.random() * 14).toFixed(1) + 's';
        s.style.animationDelay    = (-Math.random() * 20).toFixed(1) + 's';
        s.style.setProperty('--arcania-embers-drift', ((Math.random() - 0.5) * 80).toFixed(0) + 'px');
        frag.appendChild(s);
      }
      holder.appendChild(frag);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  function initSpotlight() {
    if (window.__arcaniaSpotlightInit) return;
    window.__arcaniaSpotlightInit = true;

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    function init() {
      var layer = document.querySelector('[data-arcania-spotlight]');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'arcania-spotlight';
        layer.setAttribute('data-arcania-spotlight', '');
        layer.setAttribute('aria-hidden', 'true');
        document.body.appendChild(layer);
      }

      var tx = window.innerWidth / 2;
      var ty = window.innerHeight * 0.35;
      var cx = tx;
      var cy = ty;

      var size = 320;
      var alpha = 0.19;

      var isFinePointer =
        window.matchMedia &&
        window.matchMedia('(pointer: fine)').matches;

      function setMobilePosition() {
        if (!isFinePointer) {
          tx = window.innerWidth / 2;
          ty = window.innerHeight * 0.35;
          size = 300;
          alpha = 0.19;
        }
      }

      function setDesktopPosition(e) {
        isFinePointer = true;
        tx = e.clientX;
        ty = e.clientY;
        size = 380;
        alpha = 0.16;
      }

      window.addEventListener(
        'pointermove',
        function (e) {
          if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
            setDesktopPosition(e);
          }
        },
        { passive: true }
      );

      window.addEventListener('mousemove', setDesktopPosition, {
        passive: true
      });

      window.addEventListener(
        'touchstart',
        function () {
          isFinePointer = false;
          setMobilePosition();
        },
        { passive: true }
      );

      window.addEventListener('resize', setMobilePosition);

      function tick() {
        cx += (tx - cx) * 0.1;
        cy += (ty - cy) * 0.1;

        layer.style.background =
          'radial-gradient(circle ' +
          size +
          'px at ' +
          cx +
          'px ' +
          cy +
          'px, rgba(232, 194, 92, ' +
          alpha +
          '), transparent 78%)';

        requestAnimationFrame(tick);
      }

      setMobilePosition();
      tick();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

    function initArcaniaScrollspy() {
    if (window.__arcaniaScrollspyInit) return;
    window.__arcaniaScrollspyInit = true;

    var mobileQuery = window.matchMedia
      ? window.matchMedia('(max-width: 749px)')
      : null;

    function isMobile() {
      return mobileQuery ? mobileQuery.matches : window.innerWidth <= 749;
    }

    function getScrollBehavior() {
      return window.theme && window.theme.config && window.theme.config.motionReduced
        ? 'auto'
        : 'smooth';
    }

    function getHeaderHeight() {
      var header =
        document.querySelector('.header-section header[is="sticky-header"]') ||
        document.querySelector('header[is="sticky-header"]') ||
        document.querySelector('.header-section header');

      return header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    }

    function getScrollOffset(nav) {
      var headerHeight = getHeaderHeight();
      var navHeight = Math.ceil(nav.getBoundingClientRect().height || 0);

      return headerHeight + (isMobile() ? navHeight + 12 : 20);
    }

    function getTargetIds(link) {
      var raw = link.getAttribute('data-target') || link.getAttribute('href') || '';

      return raw
        .replace(/^#/, '')
        .split(',')
        .map(function (id) {
          return id.trim();
        })
        .filter(Boolean);
    }

    function getFirstTarget(link) {
      var ids = getTargetIds(link);

      for (var i = 0; i < ids.length; i++) {
        var target = document.getElementById(ids[i]);
        if (target) return target;
      }

      return null;
    }

    function setup(nav) {
      if (!nav || nav.dataset.arcaniaScrollspyInitialized === 'true') return;

      var links = Array.prototype.slice.call(
        nav.querySelectorAll('[data-arcania-scrollspy-link], .scrollspy-link[data-target]')
      );

      if (!links.length) return;

      nav.dataset.arcaniaScrollspyInitialized = 'true';

      var activeLink = null;
      var lockedLink = null;
      var lockedUntil = 0;
      var ticking = false;

      function setActive(link, keepVisible) {
        if (!link) return;

        if (activeLink === link && link.classList.contains('active')) return;

        links.forEach(function (item) {
          item.classList.remove('active', 'is-active');
          item.removeAttribute('aria-current');

          var parent = item.closest ? item.closest('.scrollspy-item') : null;
          if (parent) {
            parent.classList.remove('active', 'is-active');
            parent.removeAttribute('aria-current');
          }
        });

        link.classList.add('active');
        link.setAttribute('aria-current', 'location');

        var activeParent = link.closest ? link.closest('.scrollspy-item') : null;
        if (activeParent) {
          activeParent.classList.add('active', 'is-active');
          activeParent.setAttribute('aria-current', 'location');
        }

        activeLink = link;

        if (keepVisible && link.scrollIntoView) {
          try {
            link.scrollIntoView({
              behavior: getScrollBehavior(),
              inline: 'center',
              block: 'nearest'
            });
          } catch (e) {}
        }
      }

      function getCurrentLink() {
        var marker = (window.pageYOffset || window.scrollY || 0) + getScrollOffset(nav) + 1;
        var current = null;
        var fallback = null;
        var fallbackTop = -Infinity;

        links.forEach(function (link) {
          var ids = getTargetIds(link);

          ids.forEach(function (id) {
            var target = document.getElementById(id);
            if (!target) return;

            var rect = target.getBoundingClientRect();
            var top = (window.pageYOffset || window.scrollY || 0) + rect.top;
            var bottom = top + target.offsetHeight;

            if (marker >= top && marker < bottom) {
              current = link;
            }

            if (top <= marker && top > fallbackTop) {
              fallback = link;
              fallbackTop = top;
            }
          });
        });

        return current || fallback || links[0];
      }

      function updateActive() {
        if (lockedLink && Date.now() < lockedUntil) {
          setActive(lockedLink, false);
          return;
        }

        lockedLink = null;
        setActive(getCurrentLink(), false);
      }

      function requestUpdate() {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(function () {
          ticking = false;
          updateActive();
        });
      }

      nav.addEventListener(
        'click',
        function (event) {
          var link = event.target.closest
            ? event.target.closest('[data-arcania-scrollspy-link], .scrollspy-link[data-target]')
            : null;

          if (link && nav.contains(link)) {
            var target = getFirstTarget(link);
            if (!target) return;

            event.preventDefault();
            event.stopPropagation();

            if (typeof event.stopImmediatePropagation === 'function') {
              event.stopImmediatePropagation();
            }

            lockedLink = link;
            lockedUntil = Date.now() + 1200;
            setActive(link, true);

            var targetTop =
              (window.pageYOffset || window.scrollY || 0) +
              target.getBoundingClientRect().top -
              getScrollOffset(nav);

            window.scrollTo({
              top: Math.max(targetTop, 0),
              behavior: getScrollBehavior()
            });

            if (history.replaceState) {
              history.replaceState(null, '', '#' + target.id);
            }

            window.setTimeout(function () {
              setActive(link, true);
            }, 350);

            window.setTimeout(function () {
              lockedLink = null;
              requestUpdate();
            }, 1300);

            return;
          }

          var backToTop = event.target.closest
            ? event.target.closest('[data-arcania-back-to-top], .back-to-top')
            : null;

          if (backToTop && nav.contains(backToTop)) {
            event.preventDefault();
            event.stopPropagation();

            window.scrollTo({
              top: 0,
              behavior: getScrollBehavior()
            });
          }
        },
        true
      );

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      requestUpdate();
    }

    function init() {
      var navs = document.querySelectorAll('[data-arcania-scrollspy]');
      Array.prototype.forEach.call(navs, setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  }
})();
